export default {
    // 基础url前缀
    baseURL: '',
    // 请求头信息
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'machineType':'h5'
    },
    timeout: 15000,
}
